import { eventTracker } from "app/modules/Segment";
import {
  FeatureEnum,
  GroupIdEnum,
  OwnerEnum,
  TContext,
  TProperties,
} from "app/modules/Segment/types";

export const LOGIN_EVENTS = {
  LOGIN_PAGE_DISPLAYED: "login_page_displayed",
  LOGIN_ATTEMPT_STARTED: "login_attempt_started",
  LOGIN_ATTEMPT_SUCCESSFUL: "login_attempt_successful",
  LOGIN_ATTEMPT_FAILED: "login_attempt_failed",
  LOGIN_FORGOT_PASSWORD_CLICKED: "login_forgot_password_clicked",
  LOGIN_SIGNUP_REDIRECT_CLICKED: "login_signup_redirect_clicked",
} as const;

const LOGIN_LIBRARY_NAME = "general-library";
const LOGIN_CATEGORY = "authentication";
const LEGACY_AUTH_VERSION = "legado";

const eventTextByEvent = {
  [LOGIN_EVENTS.LOGIN_PAGE_DISPLAYED]: "Login Page Displayed",
  [LOGIN_EVENTS.LOGIN_ATTEMPT_STARTED]: "Login Attempt Started",
  [LOGIN_EVENTS.LOGIN_ATTEMPT_SUCCESSFUL]: "Login Attempt Successful",
  [LOGIN_EVENTS.LOGIN_ATTEMPT_FAILED]: "Login Attempt Failed",
  [LOGIN_EVENTS.LOGIN_FORGOT_PASSWORD_CLICKED]:
    "Login Forgot Password Clicked",
  [LOGIN_EVENTS.LOGIN_SIGNUP_REDIRECT_CLICKED]:
    "Login Signup Redirect Clicked",
} as const;

function buildLoginContext(component: string): TContext {
  return {
    groupId: GroupIdEnum.GENERAL_GROUP,
    library: {
      name: LOGIN_LIBRARY_NAME,
      componente: component,
    },
  };
}

function trackLoginEvent({
  event,
  component,
  relevantUserActivity,
  eventMeaning,
}: {
  event: typeof LOGIN_EVENTS[keyof typeof LOGIN_EVENTS];
  component: string;
  relevantUserActivity: boolean;
  eventMeaning: string;
}): void {
  const properties: TProperties = {
    owner: OwnerEnum.PLATAFORMA,
    feature: FeatureEnum.SIGNIN,
    category: LOGIN_CATEGORY,
    event_meaning: eventMeaning,
    relevant_user_activity: relevantUserActivity,
    event_text: eventTextByEvent[event],
    auth_version: LEGACY_AUTH_VERSION,
  };

  eventTracker.track({
    event,
    properties,
    context: buildLoginContext(component),
  });
}

export function trackLoginPageDisplayed(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_PAGE_DISPLAYED,
    component: "input-component",
    relevantUserActivity: false,
    eventMeaning: "Disparado quando a página de login é exibida.",
  });
}

export function trackLoginAttemptStarted(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_ATTEMPT_STARTED,
    component: "button-component",
    relevantUserActivity: false,
    eventMeaning: "Disparado quando o usuário inicia uma tentativa de login.",
  });
}

export function trackLoginAttemptSuccessful(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_ATTEMPT_SUCCESSFUL,
    component: "button-component",
    relevantUserActivity: true,
    eventMeaning: "Disparado quando o login é concluído com sucesso.",
  });
}

export function trackLoginAttemptFailed(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_ATTEMPT_FAILED,
    component: "button-component",
    relevantUserActivity: true,
    eventMeaning: "Disparado quando uma tentativa de login falha.",
  });
}

export function trackLoginForgotPasswordClicked(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_FORGOT_PASSWORD_CLICKED,
    component: "link-component",
    relevantUserActivity: true,
    eventMeaning: "Disparado quando o usuário clica em esqueci minha senha.",
  });
}

export function trackLoginSignupRedirectClicked(): void {
  trackLoginEvent({
    event: LOGIN_EVENTS.LOGIN_SIGNUP_REDIRECT_CLICKED,
    component: "link-component",
    relevantUserActivity: true,
    eventMeaning: "Disparado quando o usuário clica para se cadastrar.",
  });
}
